import { CircleSkeleton, Skeleton } from '@/_components';

export function Loading() {
  return (
    <ul className="list-none">
      {Array.from({ length: 6 }).map((_, index) => (
        <li className="border-c-border-muted grid h-20 grid-cols-2 flex-nowrap gap-2 border-b py-2" key={index}>
          <section className="flex flex-col gap-1">
            <div className="group text-c-card-foreground decoration-primary line-clamp-1 flex items-center gap-2 text-left text-xs leading-tight font-semibold decoration-2 hover:underline">
              <Skeleton className="h-4 w-full shrink-0 grow-0" />
            </div>
            <Skeleton className="h-4 w-full shrink-0 grow-0" />
            <Skeleton className="h-3 w-3/4 shrink-0 grow-0" />
          </section>

          <section className="flex flex-col items-end justify-center gap-1.5">
            <div className="*:data-[slot=avatar]:ring-c-border flex -space-x-2 *:data-[slot=avatar]:ring-2 *:data-[slot=avatar]:grayscale">
              <CircleSkeleton className="size-5 shrink-0 grow-0" />
              <CircleSkeleton className="size-5 shrink-0 grow-0" />
              <CircleSkeleton className="size-5 shrink-0 grow-0" />
              <CircleSkeleton className="size-5 shrink-0 grow-0" />
              <CircleSkeleton className="size-5 shrink-0 grow-0" />
              <CircleSkeleton className="size-5 shrink-0 grow-0" />
              <CircleSkeleton className="size-5 shrink-0 grow-0" />
              <CircleSkeleton className="size-5 shrink-0 grow-0" />
              <CircleSkeleton className="size-5 shrink-0 grow-0" />
              <CircleSkeleton className="size-5 shrink-0 grow-0" />
            </div>

            <div className="flex items-center gap-1">
              <div className="*:data-[slot=avatar]:ring-c-border flex -space-x-2 *:data-[slot=avatar]:ring-2 *:data-[slot=avatar]:grayscale">
                <CircleSkeleton className="size-5 shrink-0 grow-0" />
                <CircleSkeleton className="size-5 shrink-0 grow-0" />
                <CircleSkeleton className="size-5 shrink-0 grow-0" />
                <CircleSkeleton className="size-5 shrink-0 grow-0" />
                <CircleSkeleton className="size-5 shrink-0 grow-0" />
                <CircleSkeleton className="size-5 shrink-0 grow-0" />
                <CircleSkeleton className="size-5 shrink-0 grow-0" />
                <CircleSkeleton className="size-5 shrink-0 grow-0" />
              </div>
            </div>
          </section>
        </li>
      ))}
    </ul>
  );
}
